import createDocumentResource from '../shared/createDocumentResource';

enum AttributeType {
  Currency = 'CURRENCY',
  Number = 'NUMBER',
  String = 'STRING',
}

interface AttributeDef {
  attrId: string;
  currencyCodeJSONPath: string;
  label: string;
  type: AttributeType;
}

export interface AppPlatformDataAttributeDef {
  attributes?: AttributeDef[];
}

const appPlatformDataAttributeDefResource = createDocumentResource<AppPlatformDataAttributeDef>({
  name: 'appPlatformDataAttributeDef',
  endpoint: 'v1/orgs/:orgId/configuration/app-platform-data-attributes-def',
});

export default appPlatformDataAttributeDefResource;
